/**
 * Translate description: Filter component for users
 */

import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useDebouncedCallback } from 'use-debounce';

import { useLanguageContext } from "../context/LanguageContext";
import Box from '@mui/joy/Box';
import Button from '@mui/joy/Button';
import Divider from '@mui/joy/Divider';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import Modal from '@mui/joy/Modal';
import ModalDialog from '@mui/joy/ModalDialog';
import ModalClose from '@mui/joy/ModalClose';
import Sheet from '@mui/joy/Sheet';
import IconButton from '@mui/joy/IconButton';
import Typography from '@mui/joy/Typography';
import Tooltip from '@mui/joy/Tooltip';

import FilterAltIcon from '@mui/icons-material/FilterAlt';
import SearchIcon from '@mui/icons-material/Search';
import { useListContext } from '../provider/ListProvider';
import { Input, Textarea } from '@mui/joy';
import { TooltipWithLink } from './TooltipWithLink';
import { useSearchParam } from '../utils/hooks/paramsHelpers';
import { useParamsContext } from '../provider/ParamsProvider';

export function SearchFilter() {
    const { t } = useLanguageContext();
    let { flushParams } = useParamsContext();
    let [searchParam, setSearchParam] = useSearchParam();
    let { setPage, loading } = useListContext();

    let debounced = useDebouncedCallback((val) => {
        setPage(1);
        flushParams()
    }, 300)

    return <Input
        value={searchParam}
        size="sm"
        placeholder={t('Search')}
        startDecorator={<SearchIcon />}
        sx={{ flexGrow: 1 }}
        onChange={(e) => {
            debounced(e.target.value)
            setSearchParam(e.target.value)
        }}
    />;
}
export function makeFilter(MainFilter, SecondaryFilter, main_label = 'Search', tooltip = null) {
    function Filters() {
        const { t } = useLanguageContext();
        const [open, setOpen] = useState(false);
        return (
            <>
                <Sheet
                    className="SearchAndFilters-mobile"
                    sx={{
                        display: { xs: 'flex', sm: 'none' },
                        my: 1,
                        gap: 1,
                    }}
                >
                    <MainFilter />
                    <IconButton
                        size="sm"
                        variant="outlined"
                        color="neutral"
                        onClick={() => setOpen(true)}
                    >
                        <FilterAltIcon />
                    </IconButton>
                    <Modal open={open} onClose={() => setOpen(false)}>
                        <ModalDialog aria-labelledby="filter-modal" layout="fullscreen">
                            <ModalClose />
                            <Typography id="filter-modal" level="h2">
                                {t('Filters')}
                            </Typography>
                            <Divider sx={{ my: 2 }} />
                            {SecondaryFilter && <Sheet sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                <SecondaryFilter />
                                <Button color="primary" onClick={() => setOpen(false)}>
                                    {t('Submit')}
                                </Button>
                            </Sheet>}
                        </ModalDialog>
                    </Modal>
                </Sheet>
                <Box
                    className="SearchAndFilters-tabletUp"
                    sx={{
                        borderRadius: 'sm',
                        py: 2,
                        display: { xs: 'none', sm: 'flex' },
                        flexWrap: 'wrap',
                        gap: 1.5,
                        '& > *': {
                            minWidth: { xs: '120px', md: '160px' },
                        },
                        flexDirection: { xs: 'column', lg: 'row' },
                    }}
                >
                    <FormControl sx={{ flex: 1 }} size="sm">
                        {
                            tooltip && <Tooltip title={
                                <TooltipWithLink to={tooltip.to} linkTitle={t('Read more in knowledge base')}>
                                    {tooltip.title}
                                </TooltipWithLink>
                            }>
                                <FormLabel>{t(main_label)}</FormLabel>
                            </Tooltip>
                        }
                        {!tooltip && <FormLabel>{t(main_label)}</FormLabel>}
                        <MainFilter />
                    </FormControl>
                    {SecondaryFilter && <SecondaryFilter />}
                </Box>
            </>
        )
    }
    return Filters
}
